import { logError } from '../../Analytics';

/**
 * Fetch function used by SWR
 */
const fetcher = async (url: string) => {
  const res = await fetch(url);
  const json = await res.json();
  if (!res.ok) {
    logError(`Error loading ${url}`, { url, res });
    throw new Error(JSON.stringify(res));
  }
  return json;
};

export default fetcher;
